var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-anchor',{attrs:{"affix":true,"offsetTop":110}},[_vm._l((_vm.data),function(item){return [_c('a-anchor-link',{key:item.href,attrs:{"href":item.href,"title":item.title}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }